import { useEffect, useRef } from "react";

export default function MentionAutocomplete({
  open = false,
  users = [],
  activeIndex = 0,
  onSelect,
  onHighlight,
  position = null,
}) {
  const listRef = useRef(null);

  useEffect(() => {
    if (!open || !listRef.current) return;
    const active = listRef.current.querySelector("[data-active='true']");
    active?.scrollIntoView({ block: "nearest" });
  }, [open, activeIndex]);

  if (!open || !users.length || !position) return null;

  return (
    <ul
      ref={listRef}
      className="mention-autocomplete"
      role="listbox"
      style={{
        top: position.top,
        left: position.left,
        transform:
          position.placement === "above" ? "translateY(calc(-100% - 6px))" : "translateY(6px)",
      }}
    >
      {users.map((user, index) => (
        <li key={user.id} role="option" aria-selected={index === activeIndex}>
          <button
            type="button"
            data-active={index === activeIndex ? "true" : "false"}
            className={index === activeIndex ? "is-active" : ""}
            onMouseEnter={() => onHighlight?.(index)}
            onMouseDown={(e) => {
              e.preventDefault();
              onSelect?.(user);
            }}
          >
            <span className="mention-autocomplete-avatar" aria-hidden>
              {(user.label || "?").charAt(0).toUpperCase()}
            </span>
            <span className="mention-autocomplete-label">{user.label}</span>
          </button>
        </li>
      ))}
    </ul>
  );
}
